// Ported from cartadigital-pos app/utils/menu-item-search.ts.
import type { IPosSearchableItem } from './pos-types';
import { normalizeText, splitTerms } from './search-normalize';

/**
 * Returns whether a menu item matches the given free-text query.
 *
 * Matching rules:
 * - diacritic-insensitive
 * - whitespace-normalized
 * - multi-term: every term must match somewhere in (name + description)
 */
export function menuItemMatchesSearch(
  item: IPosSearchableItem,
  rawQuery: string
): boolean {
  const terms = splitTerms(rawQuery);
  if (terms.length === 0) return true;

  const haystack = normalizeText(`${item.name} ${item.description ?? ''}`);
  if (!haystack) return false;

  return terms.every((t) => haystack.includes(t));
}
